var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-label"},[_c('div',{staticClass:"room-label_icon-wrapper"},[_c('img',{staticClass:"room-label_icon",attrs:{"src":_vm.icon.src,"alt":_vm.icon.alt}})]),_c('span',{staticClass:"room-label_text"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }